<template>
  <div class="group-profile-info-modify">
    <breadcrumb :breadcrumb="breadcrumb"/>
    <div class="flexBox">
      <text-title mainTitle="集团概况修改"/>
      <div class="header-btn-box">
        <a @click="updateGroupInfo">保存</a>
        <a @click="toInfoPage">取消</a>
      </div>
    </div>
    <form>
      <div class="form-line">
        <div class="line-text">集团名称：</div>
        <div class="line-info">
          <el-input v-model="formData.groupName" size="small" style="width: 280px" />
        </div>
      </div>
      <div class="form-line">
        <div class="line-text">集团电话：</div>
        <div class="line-info">
          <el-input v-model="formData.groupTelephone" size="small" style="width: 280px" />
        </div>
      </div>
      <div class="form-line">
        <div class="line-text">集团地址：</div>
        <div class="line-info">
          <el-input v-model="formData.groupAddress" size="small" style="width: 280px" />
        </div>
      </div>
      <div class="form-line">
        <div class="line-text">集团简介：</div>
        <div class="line-info">
          <el-input v-model="formData.groupIntroduce" type="textarea" :rows="5" size="small" style="width: 640px" />
        </div>
      </div>
      <div class="form-line">
        <div class="line-text">集团logo：</div>
        <div class="line-info" style="margin-left: 3px;">
          <input id="uploadBackgroundImg" name="file" accept="image/*" type="file"
                 @change="upData2" style="display: none" />
          <div style="width: 120px;height: 90px;">
            <a class="upload" @click="upImg2" v-if="!formData.groupLogo">
              <span><i class="el-icon-plus"></i></span>
              <span>点击上传</span>
            </a>
            <a class="upload2" @click="upImg2" v-if="formData.groupLogo">
              <img :src="formData.groupLogo" id="packBg" />
              <b>重新上传</b>
            </a>
          </div>
        </div>
      </div>
      <div class="form-line" style="margin: 20px 0 0 0;">
        <div class="line-text">集团展示：</div>
        <upload-img-list @getImgList="getImgList" :defaultImg="groupPicList" />
      </div>
    </form>
  </div>
</template>

<script>
  import Breadcrumb from '../../../../../components/Breadcrumb/Breadcrumb'
  import TextTitle from '../../../../../components/Text/TextTitle'
  import {api} from '../../../../api/Summary'
  import {nError, nSuccess} from '../../../../../utils/notice'
  import {errorHandler} from '../../../../../utils/errorHandler'
  import UploadImgList from '../../../../../components/Input/UploadImgList'

  export default {
    components: {
      UploadImgList,
      TextTitle,
      Breadcrumb
    },
    name: 'group-profile-info-modify',
    data () {
      return {
        breadcrumb: [{
          value: '信息发布',
          name: 'group-profile-info'
        }, {
          value: '集团概况'
        }],
        yqLogoBase64: '',
        formData: {
          groupName: '',  // 集团名称
          groupIntroduce: '', // 集团简介
          groupTelephone: '', // 集团电话
          groupAddress: '', // 集团地址
          groupLogo: '', // 集团logo
          groupPic1: '',
          groupPic2: '',
          groupPic3: '',
          groupPic4: '',
          groupPic5: '',
        },
        groupPicList: [],
        uploadGroupPicList: [],
        imageList: [],
        base64List: [],
      }
    },
    created () {
      this.getGroupInfo()
    },
    methods: {
      toInfoPage () {
        this.$router.push({
          name: 'upper-information-group-profile-info'
        })
      },

      getGroupInfo () {
        this.$axios.post(api.getGroupInfo, {})
          .then(res => {
            if (res.data.retCode === 1) {
              let data = res.data.data
              this.formData = data
              this.groupIntroduce = data.groupIntroduce.split('\n')
              if (data.groupPic1) {
                this.groupPicList.push(data.groupPic1)
              }
              if (data.groupPic2) {
                this.groupPicList.push(data.groupPic2)
              }
              if (data.groupPic3) {
                this.groupPicList.push(data.groupPic3)
              }
              if (data.groupPic4) {
                this.groupPicList.push(data.groupPic4)
              }
              if (data.groupPic5) {
                this.groupPicList.push(data.groupPic5)
              }
            }
          })
          .catch(errorHandler('查询信息失败'))
      },

      upData2: function () {
        let that = this
        const oFReader = new FileReader()
        const file = document.getElementById('uploadBackgroundImg').files[0]
        if (file.size > 1024 * 1024) {
          nError('上传图片不能大于1M')
          return false
        }
        oFReader.readAsDataURL(file)
        oFReader.onloadend = function (oFRevent) {
          const src = oFRevent.target.result
          that.yqLogoBase64 = src
          that.uploadPicture()
        }
      },
      upImg2: function () {
        $('#uploadBackgroundImg')
          .click() // 隐藏了input:file样式后，点击头像就可以本地上传
          .on('change', function () {
            // const objUrl = getObjectURL(this.files[0])
            // if (objUrl) {
            //   $('#pic2').attr('src', objUrl)
            // }
          })
      },
      // 上传图片
      uploadPicture () {
        this.$axios.post(api.uploadImg, {
          picData: this.yqLogoBase64
        })
          .then(res => {
            if (res.data.retCode === 1) {
              this.formData.groupLogo = res.data.data
            } else {
              // 提示信息，需引入Message
              nError('图片上传失败')
            }
          })
          .catch(errorHandler('图片上传失败'))
      },

      getImgList (imageList, base64List) {
        this.imageList = imageList
        this.base64List = base64List
      },

      // 上传图片
      uploadPictureToGetUrl (base64) {
        return this.$axios.post(api.uploadImg, {
          picData: base64
        })
      },

      async upApartmentLayoutImageList () {
        let yqApartmentLayoutDiagramListArr = []
        for (let k = 0; k < this.imageList.length; k++) {
          if (!this.imageList[k].name) {
            yqApartmentLayoutDiagramListArr.push(this.imageList[k].src)
          }
          for (let j = 0; j < this.base64List.length; j++) {
            if (this.imageList[k].name && this.imageList[k].name.split('.')[0] === this.base64List[j].code) {
              let imgUrl = ''
              await this.uploadPictureToGetUrl(this.base64List[j].personImageStr)
                .then(res => {
                  imgUrl = res.data.data
                })
                .catch(errorHandler('图片上传失败'))
              yqApartmentLayoutDiagramListArr.push(imgUrl)
            }
          }
        }
        this.uploadGroupPicList = yqApartmentLayoutDiagramListArr
      },

      // 保存修改
      async updateGroupInfo () {
        await this.upApartmentLayoutImageList()
        if (this.uploadGroupPicList[0]) {
          this.formData.groupPic1 = this.uploadGroupPicList[0]
        }
        if (this.uploadGroupPicList[1]) {
          this.formData.groupPic2 = this.uploadGroupPicList[1]
        }
        if (this.uploadGroupPicList[2]) {
          this.formData.groupPic3 = this.uploadGroupPicList[2]
        }
        if (this.uploadGroupPicList[3]) {
          this.formData.groupPic4 = this.uploadGroupPicList[3]
        }
        if (this.uploadGroupPicList[4]) {
          this.formData.groupPic5 = this.uploadGroupPicList[4]
        }
        this.$axios.post(api.updateGroupInfo, this.formData)
          .then(res => {
            if (res.data.retCode === 1) {
              nSuccess('修改成功')
              this.toInfoPage()
            }
          })
          .catch(errorHandler('修改失败'))
      }
    }
  }
</script>

<style scoped>
  .flexBox {
    display: flex;
    justify-content: space-between;
  }
  .header-btn-box {
    margin: 20px 0 10px 0;
    color: #337ab7;
    font-size: 14px;
  }
  .header-btn-box a{
    margin-right: 40px;
    cursor: pointer;
  }
  .header-btn-box a:hover{
    color: #00a0e6;
  }
  form {
    width: 90%;
    margin: 0 auto;
    text-align: left;
  }
  .red {
    color: #FF0000;
    vertical-align: top;
  }
  .form-line {
    margin: 5px 0 0 0;
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }
  .line-text{
    width: 100px;
    color: #48576a;
    font-size: 14px;
  }
  .form-title {
    color: #333;
    font-size: 16px;
    line-height: 28px;
    padding-left: 5px;
    border-left: 3px solid #00a0e6;
  }
  .textBox {
    display: inline-block;
    width: 110px;
    height: 50px;
    line-height: 50px;
    text-align: right;
  }
  .line-info {
    width: 220px;
    line-height: 50px;
  }
  .form-btn-box {
    width: 530px;
    padding: 0 124px;
    margin-top: 40px;
    display: flex;
    justify-content: space-between;
  }

  .newly {
    display: inline-block;
    width: 64px;
    height: 64px;
    vertical-align: text-top;
    border: 1px dashed #D7D7D7;
    margin-right: 20px;
    position: relative;
  }

  .newly2 {
    display: inline-block;
    width: auto;
    height: 50px;
    vertical-align: text-top;
    border: 1px dashed #D7D7D7;
    position: relative;
  }

  #pic {
    width: 64px;
    height: 64px;
  }

  .newly span {
    display: block;
    width: 100%;
    color: #999999;
    margin: 0;
    padding: 0;
    text-align: center;
  }

  .newly2 span {
    display: block;
    width: 100%;
    color: #999999;
    margin: 0;
    padding: 0;
    text-align: center;
  }

  .newly span:first-child {
    font-size: 12px;
    line-height: 20px;
    position: absolute;
    top: 15px;
  }

  .newly2 span:first-child {
    font-size: 20px;
    line-height: 60px;
    position: absolute;
  }

  .newly span:last-child {
    font-size: 14px;
    line-height: 20px;
    position: absolute;
    bottom: 0;
  }

  .newly2 span:last-child {
    font-size: 12px;
    line-height: 20px;
    position: absolute;
    bottom: 0;
  }

  .upload {
    display: inline-block;
    width: 120px;
    height: 90px;
    vertical-align: text-top;
    background-size: 100% 100%;
    position: relative;
    border: 1px dashed #D7D7D7;
  }

  .upload2 {
    display: block;
    width: 120px;
    height: 90px;
    vertical-align: text-top;
    background-size: 100% 100%;
    position: relative;
    border: 1px dashed #D7D7D7;
  }

  .upload img, .upload2 img {
    width: 120px;
    height: 90px;
    border-radius: 5px;
  }

  .upload b {
    display: inline-block;
    width: 100%;
    line-height: 21px;
    font-size: 12px;
    color: white;
    background-color: #989796;
    text-align: center;
    position: absolute;
    left: 0;
    bottom: 0;
    opacity: .7;
  }

  .upload2 b {
    display: inline-block;
    width: 100%;
    line-height: 21px;
    font-size: 12px;
    color: white;
    background-color: #989796;
    text-align: center;
    position: absolute;
    left: 0;
    bottom: 0;
    opacity: .7;
  }

  .upload span {
    display: block;
    width: 100%;
    color: #999999;
    margin: 0;
    padding: 0;
    text-align: center;
  }

  .upload span:first-child {
    font-size: 24px;
    line-height: 20px;
    position: absolute;
    top: 25px;
  }

  .upload span:last-child {
    font-size: 14px;
    line-height: 20px;
    position: absolute;
    bottom: 0;
  }

  .upload2 span {
    width: 120px;
    display: block;
    text-align: center;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
</style>




// WEBPACK FOOTER //
// src/view/UpperStrata/Summary/InformationDelivery/GroupProfile/GroupProfileInfoModify.vue